import React from "react";
import { timeline } from "../data/salesContent";
export function Timeline() {
  return <section aria-labelledby="treinta" className="w-full bg-white py-16 lg:py-24" data-id="element-164" data-mp="35wf6tro54fn0">
      <div className="mx-auto max-w-6xl px-5" data-id="element-165" data-mp="2s4h3xyl0vfza">
        <h2 id="treinta" className="text-center font-display text-3xl font-black text-ink sm:text-5xl" data-id="element-166" data-mp="2s3pllpgfreqy">
          En 30 días
        </h2>

        <ol className="relative mt-14 grid gap-10 md:grid-cols-3 md:gap-8" data-id="element-167" data-mp="2w3pzn8zmhnxh">
          <div className="absolute left-0 right-0 top-[11px] hidden h-0.5 bg-cream-deep md:block" aria-hidden="true" data-id="element-168" data-mp="2i4zzfkhib84w" />
          {timeline.map(step => <li key={step.days} className="relative" data-id="element-169" data-mp="296elk2mzchag">
              <span className="relative block h-6 w-6 rounded-full border-4 border-white bg-gold ring-2 ring-gold" aria-hidden="true" data-id="element-170" data-mp="297ps2a7t8359" />
              <p className="mt-5 font-display text-sm font-extrabold uppercase tracking-wider text-gold-deep" data-id="element-171" data-mp="7dqgrouotlsk">
                {step.days}
              </p>
              <h3 className="mt-1 font-display text-xl font-extrabold text-ink" data-id="element-172" data-mp="bdr45yzrl7br">{step.title}</h3>
              <p className="mt-2 leading-relaxed text-muted" data-id="element-173" data-mp="2n54q08cozja7">{step.detail}</p>
            </li>)}
        </ol>

        <div className="mt-14 flex flex-col items-center justify-between gap-4 rounded-2xl bg-cream px-8 py-6 text-center sm:flex-row sm:text-left" data-id="element-174" data-mp="2wx11cl3sh5wd">
          <p className="font-display text-lg font-bold text-ink" data-id="element-175" data-mp="2rz8xqtts7vcc">Resultado esperado</p>
          <p className="font-display text-3xl font-black text-gold-deep sm:text-4xl" data-id="element-176" data-mp="247k3h7xegwsr">$300–500 ganados</p>
        </div>
      </div>
    </section>;
}